// extracted by mini-css-extract-plugin
module.exports = {"default":"RadioGroup__default__1N7o3","label":"RadioGroup__label__1UkGC"};